import { StateManager } from '../stateManager';

import {
  SET_ORDER_SHIMMER,
  SET_BASIC_ORDER_INFO,
  SET_ISSUE_SUBMISSION,
  CLOSE_ACTION_VIEW,
} from './actions';

export const IS_SIDEBAR_CLOSE = 'isSidebarClose';

export const initialState = {
  isOrderShimmer: true,
  orderInfo: null,
  issueSubmission: false,
  isActionViewClose: (() => {
    try {
      const val = localStorage.getItem(IS_SIDEBAR_CLOSE);
      return val !== null ? val === 'true' : false;
    } catch (e) {
      return false;
    }
  })(),
};

const setOrderShimmer = (state, action) => {
  let { value } = action;
  return { ...state, isOrderShimmer: value };
};

const closeActionView = (state, action) => {
  let { value } = action;
  return { ...state, isActionViewClose: value };
};

const setBasicOrderInfo = (state, action) => {
  let { orderInfo } = action;
  return { ...state, orderInfo: { ...state.orderInfo, ...orderInfo } };
};

const setIssueSubmission = (state, action) => {
  let { value } = action;
  return { ...state, issueSubmission: value };
};

const actions = {
  [SET_ORDER_SHIMMER]: setOrderShimmer,
  [SET_BASIC_ORDER_INFO]: setBasicOrderInfo,
  [SET_ISSUE_SUBMISSION]: setIssueSubmission,
  [CLOSE_ACTION_VIEW]: closeActionView,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
